import { CheckCircle2, ShieldCheck } from 'lucide-react';

import ContentPage from '../components/ui/ContentPage';

const PILLARS = [
  {
    title: 'Identidade verificable',
    body: 'Cada usuario asina os eventos coa súa propia chave ECDSA P-256 xerada no Secure Enclave (iOS) ou StrongBox (Android). A chave privada nunca sae do dispositivo.',
  },
  {
    title: 'Anclaxe blockchain diaria',
    body: 'Construímos un Merkle root diario cos hashes de todos os eventos do día e publicámolo en Polygon. Calquera persoa pode verificar a inclusión dun evento sen depender de nós.',
  },
  {
    title: 'Pagamentos en escrow',
    body: 'Os cargos por compra retéñense ata que o comprador confirma a entrega. Se hai disputa, o equipo media e devolve o depósito segundo a evidencia trazable.',
  },
  {
    title: 'Conta protexida',
    body: 'Soportamos contrasinal forte + 2FA TOTP con códigos de respaldo. As sesións son revocables individualmente por dispositivo.',
  },
];

const BEST_PRACTICES = [
  'Activa 2FA no teu perfil — é gratis e bloquea o 99 % dos accesos non autorizados.',
  'Non compartas o teu contrasinal con ninguén. LeyroChain nunca cho pedirá por email.',
  'Revisa periódicamente os dispositivos conectados; revoga calquera que non recoñezas.',
  'No NFC scan en campo, comproba que a app mostra o crotal correcto antes de asinar un evento.',
  'Se vendes un animal, valida que o comprador é unha conta verificada antes de entregar.',
];

export default function SecurityPage(): JSX.Element {
  return (
    <ContentPage
      title="Seguridade da plataforma"
      intro="Como protexemos a túa identidade, os teus animais e o teu diñeiro."
      category="Información"
    >
      <h2>Os 4 piares</h2>
      <ul className="not-prose space-y-4">
        {PILLARS.map((p) => (
          <li
            key={p.title}
            className="flex items-start gap-3 border border-border rounded-2xl p-5 bg-white"
          >
            <ShieldCheck size={22} className="text-rauxa mt-0.5 shrink-0" />
            <div>
              <h3 className="font-semibold text-dark mb-1">{p.title}</h3>
              <p className="text-sm text-muted leading-relaxed">{p.body}</p>
            </div>
          </li>
        ))}
      </ul>

      <h2>Boas prácticas para o teu día a día</h2>
      <ul className="not-prose space-y-2">
        {BEST_PRACTICES.map((b) => (
          <li key={b} className="flex items-start gap-3">
            <CheckCircle2 size={16} className="text-rauxa mt-1 shrink-0" />
            <span className="text-sm text-dark leading-relaxed">{b}</span>
          </li>
        ))}
      </ul>

      <h2>Reporta unha vulnerabilidade</h2>
      <p>
        Se atopas un bug de seguranza, comunícao a <a href="mailto:info@leyro.es">info@leyro.es</a>{' '}
        con detalle reproducible. Garantízamosche resposta en 48 horas laborais.
      </p>
    </ContentPage>
  );
}
